import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isFalse',
  standalone: true,
})
export class IsFalsePipe implements PipeTransform {
  public transform(value: unknown): boolean {
    return value === false;
  }
}
